import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AbstractApi, ApiProps } from '../apis/AbstractApi';
import useSharedAuthLib from './useSharedAuthLib';

/**
 * Use the specified api. It will be created automatically by this call
 * @param creator The api that will be used
 * @returns The specified api
 */
export default function useApi<T extends AbstractApi>(
  creator: new (_: ApiProps) => T
) {
  const authLib = useSharedAuthLib();
  const navigate = useNavigate();

  const api = useMemo(
    () =>
      new creator({
        authLib: authLib,
        navigate: navigate,
      }),
    [creator, authLib, navigate]
  );

  return api;
}
